/* eslint-disable array-callback-return */
/*
 * 所有商品
 */
import React from "react";
import {
  message,
  Spin,
  Dropdown,
  Menu,
  Tooltip,
  Modal,
  Affix,
  Button,
  Carousel,
  Cascader,
  Select,
  Tag, 
} from "antd";
import InfiniteScroll from "react-infinite-scroller";
import { API, history, IconFont, imgRoot } from "../../static/js/common";
import moment from "moment";
import { LoginContext } from "../../App";
import CryptoJS from 'crypto-js';
import { withRouter } from 'react-router-dom';
import { StarOutlined, StarFilled, QuestionCircleOutlined, SoundOutlined } from '@ant-design/icons';
import 'antd/dist/antd.css';

const { Option } = Select;

// const courier_list = ["全部", "韵达", "圆通", "顺丰", "申通", "邮政", "百世"];

// const platform_list = ["全部", "淘宝/天猫", "京东", "拼多多", "其它"];
const paly_list = [{key: 2,playKey:'全部'},{key: 0,playKey:'手动下单'},{key: 1,playKey:'自动下单'}]

const list_data = [{list:'all',name:'全部'},{list:'hot',name:'热销榜'},{list:'new',name:'黑马榜'},{list:'fast',name:'快速揽收榜'}]

const overtimePaid_list = [
  { overtimePaid: "全部" },
  { overtimePaid: "支持" },
  { overtimePaid: "不支持" },
];

const cityData = {
  '安徽': ['合肥', '安庆', '蚌埠', '亳州', '巢湖', '池州', '滁州', '阜阳', '淮北', '淮南', '黄山', '六安', '马鞍山', '宿州', '铜陵', '芜湖', '宣城'],
  '北京': ['昌平', '朝阳区', '崇文', '大兴', '东城', '房山', '丰台', '海淀', '怀柔', '门头沟', '密云', '平谷', '石景山', '顺义', '通州区', '西城', '宣武', '延庆'],
  '福建': ['福州', '龙岩', '南平', '宁德', '莆田', '泉州', '三明', '厦门', '漳州'],
  '甘肃': ['兰州', '白银', '定西', '甘南', '嘉峪关', '金昌', '酒泉', '临夏', '陇南', '平凉', '庆阳', '天水', '武威', '张掖'],
  '广东': ['广州', '潮州', '东莞', '佛山', '河源', '惠州', '江门', '揭阳', '茂名', '梅州', '清远', '汕头', '汕尾', '韶关', '深圳', '阳江', '云浮', '湛江', '肇庆', '中山', '珠海'],
  '广西': ['桂林', '百色', '北海', '崇左', '防城港', '贵港', '河池', '贺州', '来宾', '柳州', '南宁', '钦州', '梧州', '玉林'],
  '贵州': ['贵阳', '安顺', '毕节', '六盘水', '黔东南', '黔南', '黔西南', '铜仁', '遵义'],
  '海南': ['海口', '白沙', '保亭', '昌江', '澄迈', '儋州', '定安', '东方', '乐东', '临高', '陵水', '南沙群岛', '琼海', '琼中', '三亚', '屯昌', '万宁', '文昌', '五指山', '西沙群岛', '中沙群岛'],
  '河北': ['石家庄', '保定', '沧州', '承德', '邯郸', '衡水', '廊坊', '秦皇岛', '唐山', '邢台', '张家口'],
  '河南': ['郑州', '安阳', '鹤壁', '焦作', '济源', '开封', '洛阳', '漯河', '南阳', '平顶山', '濮阳', '三门峡', '商丘', '新乡', '信阳', '许昌', '周口', '驻马店'],
  '黑龙江': ['哈尔滨', '大庆', '大兴安岭', '鹤岗', '黑河', '鸡西', '佳木斯', '牡丹江', '七台河', '齐齐哈尔', '双鸭山', '绥化', '伊春'],
  '湖北': ['武汉', '鄂州', '恩施', '黄冈', '黄石', '荆门', '荆州', '潜江', '神农架', '十堰', '随州', '天门', '仙桃', '咸宁', '襄樊', '孝感', '宜昌'],
  '湖南': ['长沙', '常德', '郴州', '衡阳', '怀化', '娄底', '邵阳', '湘潭', '湘西', '益阳', '永州', '岳阳', '张家界', '株洲'],
  '吉林': ['长春', '白城', '白山', '吉林', '辽源', '四平', '松原', '通化', '延边'],
  '江苏': ['南京', '常州', '淮安', '连云港', '南通', '苏州', '宿迁', '泰州', '无锡', '徐州', '盐城', '扬州', '镇江'],
  '江西': ['南昌', '抚州', '赣州', '吉安', '景德镇', '九江', '萍乡', '上饶', '新余', '宜春', '鹰潭'],
  '辽宁': ['沈阳', '鞍山', '本溪', '朝阳市', '大连', '丹东', '抚顺', '阜新', '葫芦岛', '锦州', '辽阳', '盘锦', '铁岭', '营口'],
  '内蒙古': ['呼和浩特', '阿拉善', '巴彦淖尔', '包头', '赤峰', '鄂尔多斯', '呼伦贝尔', '通辽', '乌海', '乌兰察布', '锡林郭勒', '兴安'],
  '宁夏': ['银川', '固原', '石嘴山', '吴忠', '中卫'],
  '青海': ['西宁', '果洛', '海北', '海东', '海南', '海西', '黄南', '玉树'],
  '山东': ['济南', '滨州', '德州', '东营', '菏泽', '济宁', '莱芜', '聊城', '临沂', '青岛', '日照', '泰安', '威海', '潍坊', '烟台', '枣庄', '淄博'],
  '山西': ['太原', '长治', '大同', '晋城', '晋中', '临汾', '吕梁', '朔州', '忻州', '阳泉', '运城'],
  '陕西': ['西安', '安康', '宝鸡', '汉中', '商洛', '铜川', '渭南', '咸阳', '延安', '榆林'],
  '上海': ['宝山', '长宁', '崇明', '奉贤', '虹口', '黄浦', '嘉定', '金山', '静安', '卢湾', '闵行', '南汇', '浦东', '普陀', '青浦', '松江', '徐汇', '杨浦', '闸北'],
  '四川': ['成都', '阿坝', '巴中', '达州', '德阳', '甘孜', '广安', '广元', '乐山', '凉山', '泸州', '眉山', '绵阳', '内江', '南充', '攀枝花', '遂宁', '雅安', '宜宾', '资阳', '自贡'],
  '天津': ['宝坻', '北辰', '大港', '东丽', '汉沽', '和平', '河北', '河东', '河西', '红桥', '蓟县', '津南', '静海', '南开', '宁河', '塘沽', '武清', '西青'],
  '西藏': ['拉萨', '阿里', '昌都', '林芝', '那曲', '日喀则', '山南'],
  '新疆': ['乌鲁木齐', '阿克苏', '阿拉尔', '阿勒泰', '巴音郭楞', '博尔塔拉', '昌吉', '哈密', '和田', '喀什', '克拉玛依', '克孜勒苏柯尔克孜', '石河子', '塔城', '图木舒克', '吐鲁番', '五家渠', '伊犁'],
  '云南': ['昆明', '保山', '楚雄', '大理', '德宏', '迪庆', '红河', '丽江', '临沧', '怒江', '曲靖', '思茅', '文山', '西双版纳', '玉溪', '昭通'],
  '浙江': ['杭州', '湖州', '嘉兴', '金华', '丽水', '宁波', '衢州', '绍兴', '台州', '温州', '舟山'],
  '重庆': ['巴南', '北碚', '璧山', '长寿', '城口', '大渡口', '大足', '垫江', '丰都', '奉节', '涪陵', '合川', '江北', '江津', '九龙坡', '开县', '梁平', '南岸', '南川', '彭水', '綦江', '黔江', '荣昌', '沙坪坝', '石柱', '双桥', '铜梁', '潼南', '万盛', '万州', '巫山', '巫溪', '武隆', '秀山', '永川', '酉阳', '渝北', '渝中', '云阳', '忠县'],
};

 // 基础按钮样式
 const baseButtonStyle = {
  padding: '8px 12px',
  borderRadius: '30px',
  border: '2px solid #e0e0e0',
  cursor: 'pointer',
  transition: 'all 0.3s cubic-bezier(0.4, 0, 0.2, 1)',
  fontSize: '16px',
  fontWeight: 600,
  margin: '0 10px',
  position: 'relative',
  overflow: 'hidden',
  background: 'white'
};

// 选中状态特效
const selectedStyle = (isSelected) => ({
  ...baseButtonStyle,
  border: isSelected ? '2px solid transparent' : '2px solid #e0e0e0',
  background: isSelected ? 
    'linear-gradient(45deg, #ff6b6b, #ff8e53) padding-box, linear-gradient(45deg, #ff6b6b, #ff8e53) border-box' : 'white',
  color: isSelected ? 'white' : '#666',
  transform: isSelected ? 'scale(1.05)' : 'none',
  boxShadow: isSelected ? '0 8px 24px rgba(255,107,107,0.3)' : 'none',
  '::after': isSelected ? { // 选中波纹动画
    content: '""',
    position: 'absolute',
    top: '50%',
    left: '50%',
    width: '200%',
    height: '200%',
    background: 'rgba(255,255,255,0.1)',
    borderRadius: '50%',
    transform: 'translate(-50%, -50%) scale(0)',
    animation: 'ripple 0.6s ease-out'
  } : {}
});


// 转换为联级数据
function convertToCascaderData(data) {
  return Object.keys(data).map(province => ({
    label: province,
    value: province,
    children: data[province].map(city => ({
      label: city,
      value: city
    }))
  }));
}

const cascaderData = convertToCascaderData(cityData);

class All extends React.Component {  
  static contextType = LoginContext;
  constructor(props) {
    super(props);
    this.state = {
      isShowModal: false,
      isShowBuy: "", // 购买按钮
      page: 1,
      pageSize: 20,
      // sortBy: "goods_fee",
      sortBy: "",
      type1: 1,
      type2: 1,
      goods_list: [],
      hasMore: true,
      loading: false,
      address: "全部",
      courier: "全部",
      platform: "",
      autoPay: null,
      overtimePaid: "",
      // isAddressRotate: false,
      // isPlatformRotate: false,
      isCourierRotate: false,
      isOvertimeRotate: false,
      address_list: [],
      courier_list: [],
      platform_list: [],
      isLine: true,
      imgType: 'main',
      goodsId: '',
      shuiyin: 'https://cdn.abc11223.com/source/daifa/shuiyin1.png',
      isAuth: 0,
      isShowAuth: false,
      canUse: 1,
      isShowModalImg: false,
      imgVisible: true ,// 新增状态
      selectedTab:'all',
    };
  }

  hideTimer = null;

  componentDidMount() {

    //每天只弹出一次
    let isShowModal = false;
    // 设置5秒后修改状态
    // this.hideTimer = setTimeout(() => {
    //   this.setState({ imgVisible: false });
    // }, 5000);
    const todayDate = window.localStorage.getItem("LP-TODAY-ONLY");
    const todayNowDate = moment().format("YYYY-MM-DD");

    if (todayDate !== todayNowDate) {
      isShowModal = false;
      window.localStorage.setItem("LP-TODAY-ONLY", todayNowDate);
    }
    this.setState({ isShowModal });
    this.getGoodsList();
    
    // API.postWarehouse({}).then((res) => {
    //   if (res.status * 1 === 0) {
    //     const address_list = ["全部"];
    //     const data = res.extData || [];
    //     data.map((item) => {
    //       if (address_list.indexOf(item.address) === -1) {
    //         address_list.push(item.address);
    //       }
    //     });
    //     this.setState({ address_list });
    //   } else {
    //     message.error(res.message || "仓库列表获取失败");
    //   }
    // });
    API.postSelectOption({}).then((res) => {
      if (res.status * 1 === 0) {
        const data = res.extData || {};
        const courier_list = data.courier || [];
        const platform_list = data.platform || [];
        const address_list = data.city || [];
        this.setState({ courier_list, platform_list, address_list });
      } else {
        message.error(res.message || "数据加载错误");
      }
    });
    API.getAuthInfo({}).then((res) => {
      if (res.status * 1 === 0) {
        const data = res.extData;

        // if(data.realSms) {
        this.setState({
          isAuth: data.needRealName,
          canUse: parseInt(data.canUse)
        })
        // }
      }
    })
  }

  componentWillUnmount() {
    clearTimeout(this.hideTimer);
  }
 
  urlBase64Encrypt = () => {
    const _bitArray = CryptoJS.enc.Utf8.parse(this.state.shuiyin);
    return CryptoJS.enc.Base64.stringify(_bitArray)
      .replace(/\+/g, '-')
      .replace(/\//g, '_');
    //|watermark/1/blogo/2/image/${this.urlBase64Encrypt()}/gravity/southeast/dx/20/dy/20
  };

  getGoodsList = (value) => {
    const {
      page,
      pageSize,
      sortBy,
      type1,
      type2,
      address,
      courier,
      platform,
      autoPay,
      overtimePaid,
      selectedTab
    } = this.state;
    
    const reqData = {
      page,
      pageSize,
      sortBy,
      address,
      courier,
      platform,
      autoPay,
      overtimePaid: -1,
    };
    
    reqData.sortType = sortBy === "goods_fee" ? type1 : type2;
    if (address === "全部") {
      reqData.address = "";
    }
    if (courier === "全部") {
      reqData.courier = "";
    }
    switch (overtimePaid) {
      case "全部":
        reqData.overtimePaid = -1;
        break;
      case "支持":
        reqData.overtimePaid = 1;
        break;
      case "不支持":
        reqData.overtimePaid = 0;
        break;
      default:
        break;
    }
    switch (platform) {
      case "全部":
        reqData.platform = "";
        break;
      case "淘宝/天猫":
        reqData.platform = 1;
        break;
      case "京东":
        reqData.platform = 2;
        break;
      case "拼多多":
        reqData.platform = 3;
        break;
      case "抖音":
        reqData.platform = 5;
        break;
      case "其它":
        reqData.platform = 4;
        break;
      default:
        break;
    }
    switch (autoPay) {
      case "全部":
        reqData.autoPay = 2;
        break;
      case "手动下单":
        reqData.autoPay = 0;
        break;
      case "自动下单":
        reqData.autoPay = 1;
        break;
      default:
        break;
    }
    switch (selectedTab) {
      case "all":
        reqData.isHot = 0;
        break;
      case "hot":
        reqData.isHot = 1;
        break;
      case "new":
        reqData.isHot = 2;
        break;
      case "fast":
        reqData.address = "安徽省"
        reqData.courier = "韵达快递"
        break;
      default:
        break;
    }

    this.setState({ loading: true });
    if(value==='selectedTab'){
      this.setState({
        goods_list: [],
      });
    }
    API.postGoodsList(reqData).then((res) => {
      this.setState({ loading: false });
      if (res.status * 1 === 0) {
        let { goods_list } = this.state;
        const data = res.extData || {};
        goods_list = goods_list.concat(data.list || []);
        const collectArr = [],
          noCollectArr = [];
        goods_list.map((item) => {
          item.isCollect * 1 === 1
            ? collectArr.push(item)
            : noCollectArr.push(item);
        });
        
        this.setState({
          goods_list: collectArr.concat(noCollectArr),
          hasMore: goods_list.length !== data.total * 1,
        });
      } else {
        message.error(res.message || "数据加载错误");
        this.setState({ hasMore: false });
      }
    });
  };

  // 收藏列表
  getCollectList = () => {
    const { page, pageSize } = this.state;
    const reqData = {
      page,
      pageSize,
    };
    this.setState({ loading: true });
    API.postCollectList(reqData).then((res) => {
      this.setState({ loading: false });
      if (res.status * 1 === 0) {
        let { goods_list } = this.state;
        const data = res.extData || {};
        goods_list = goods_list.concat(data.list || []);
        this.setState({
          goods_list,
          hasMore: goods_list.length !== data.total * 1,
        });
      } else {
        message.error(res.message || "数据加载错误");
        this.setState({ hasMore: false });
      }
    });
  };

  changeSort = (type, str) => {
    const { loading, sortBy } = this.state;
    if (loading) return;
    const obj = { goods_list: [], page: 1 };
    if (type === "collect") {
      if (str === 0) {
        message.error("请登录", 1.2, (_) =>
          this.props.history.push("/login?tabKey=login")
        );
        return;
      }
      obj.sortBy = type;
      this.setState(obj, (_) => this.getCollectList());
    } else {
      // if (sortBy === type) {
      //   obj[str] = 3 - this.state[str];
      // } else {
      //   obj.sortBy = type;
      //   obj[str] = 1;
      // }
      // this.setState(obj, (_) => this.getGoodsList());
      if (sortBy === type) {
        const currentOrder = this.state[str];
        // 状态循环：1（升序）→ 2（降序）→ 重置
        if (currentOrder === 1) {
          obj[str] = 2; // 切换降序
        } else if (currentOrder === 2) {
          obj.sortBy = null; // 清除排序类型
          obj[str] = 1;  // 重置排序状态
        } else {
          // 异常情况恢复默认
          obj.sortBy = type;
          obj[str] = 1;
        }
      } else {
        // 切换新排序类型，默认升序
        obj.sortBy = type;
        obj[str] = 1;
      }
      this.setState(obj, () => this.getGoodsList());
    }
  };

  /* chooseAddress = (e) => {
    this.setState({ address: e, goods_list: [], page: 1 }, (_) =>
      this.getGoodsList()
    );
  }; */

  handleSelect = (e, state) => {
    
    const o = {
      goods_list: [],
      page: 1,
      isCourierRotate: false,
      isPlatformRotate: false,
      isPlatformRotatePlace: false,
      isAddressRotate: false,
      isOvertimeRotate: false,
    };
    o[state] = e;
    
    this.setState(o, (_) => this.getGoodsList());
  };

  handHot = (e) => {
    
    this.setState({ selectedTab: e }, (_) => this.getGoodsList())
    
  }

  handleChangeItem = (key, value) => {
    const o = {
      goods_list: [],
      page: 1,
    };
    o[key] = value;
    this.setState(o, (_) => this.getGoodsList());
  };

  // 下拉加载
  handleMoreGoodList = () => {
    const { page, hasMore, loading } = this.state;
    if (loading || !hasMore) return;
    this.setState({ page: page + 1 }, (_) => this.getGoodsList());
  };

  // 立即购买
  handlePay = (item) => {

    if (!parseInt(item.stock)) {
      message.warn("库存不足");
      return;
    }
    // if (this.state.canUse === 2) {
    //   message.warn({
    //     content:"余额不足，请前往个人中心充值，即可购买",
    //     style: {
    //       fontSize: 18,
    //     },
    //     duration:5
    //   });
    //   return;
    // }
    if (parseInt(this.state.isAuth) === 1) {
      this.setState({
        isShowAuth: true
      })
      return;
    }
    if (item.status * 1 === 1) {
      this.props.history.push(
        `/seller/goods/goodsinfo?${item.goodsId}`
      )
    } else {
      message.warn("商品已下架");
    }
  };

  toAuth = () => {
    window.open(`/#/seller/account/home?status=1`, '_blank')
  };

  // 收藏、取消收藏
  handleCollect = (goodsId, isCollect, isLogin, idx, e) => {
    e.stopPropagation();
    if (isLogin === 0) {
      message.error("请登录", 1.2, (_) => this.props.history.push("/login?tabKey=login"));
      return;
    }
    const reqData = { goodsId, act: isCollect === 0 ? "add" : "del" };
    API.postHandleCollect(reqData).then((res) => {
      if (res.status * 1 === 0) {
        const { goods_list } = this.state;
        const new_goods_list = JSON.parse(JSON.stringify(goods_list));
        new_goods_list[idx].isCollect = 1 - isCollect;
        this.setState({
          goods_list: new_goods_list,
        });
        message.success(
          `${isCollect === 0 ? "收藏成功" : "取消收藏成功"}`,
          1.2
        );
      } else {
        message.error(res.message || "操作失败，请稍后再试！");
      }
    });
  };

  renderMenuItem = (arr, myKey, state, str) => (
    <Menu
      selectedKeys={[myKey]}
      onClick={(e) => this.handleSelect(e.key, state)}
    >
      {arr.map((item) => (
        <Menu.Item key={item[str]}>{item[str]}</Menu.Item>
      ))}
    </Menu>
  );

  renderMenuPlaceItem = (myKey) => (
    <Menu
      selectedKeys={[myKey]}
      onClick={(e) => this.handleSelect(e.key, 'autoPay')}
    >
      {paly_list.map((item) => (
        // <Menu.Item key={item['playKey']}>{item['playKey']}</Menu.Item>
        <Menu.Item key={item['playKey']}>
          <div style={{ display: 'flex', alignItems: 'center', gap: 8 }}>
            <span>{item['playKey']}</span>
            {
              item.key === 1 && (
                <Tooltip 
                title='自动获取店铺订单，无需导出、填写'
                placement="right"
                overlayStyle={{ maxWidth: 300 }}
              >
                <QuestionCircleOutlined 
                  style={{ color: '#999', fontSize: 12, cursor: 'help' }}
                />
              </Tooltip>
              ) 
            }
             {
              item.key === 0 && (
                <Tooltip 
                title='填写或批量导入收件人信息'
                placement="right"
                overlayStyle={{ maxWidth: 300 }}
              >
                <QuestionCircleOutlined 
                  style={{ color: '#999', fontSize: 12, cursor: 'help' }}
                />
              </Tooltip>
              ) 
            }
          </div>
        </Menu.Item>
      ))}
    </Menu>
  );

  handleChange = (value) => {
    console.log('选中的省市区:', value);
    const {
      page,
      pageSize,
      sortBy,
      type1,
      type2,
      address,
      courier,
      platform,
      autoPay,
      overtimePaid,
      selectedTab,
    } = this.state;
    const reqData = {
      page,
      pageSize,
      sortBy,
      address,
      courier,
      platform,
      autoPay,
      
      overtimePaid: -1,
    };
    
    reqData.sortType = sortBy === "goods_fee" ? type1 : type2;
    if (address === "全部") {
      reqData.address = "";
    }
    if (courier === "全部") {
      reqData.courier = "";
    }
    switch (overtimePaid) {
      case "全部":
        reqData.overtimePaid = -1;
        break;
      case "支持":
        reqData.overtimePaid = 1;
        break;
      case "不支持":
        reqData.overtimePaid = 0;
        break;
      default:
        break;
    }
    switch (platform) {
      case "全部":
        reqData.platform = "";
        break;
      case "淘宝/天猫":
        reqData.platform = 1;
        break;
      case "京东":
        reqData.platform = 2;
        break;
      case "拼多多":
        reqData.platform = 3;
        break;
      case "抖音":
        reqData.platform = 5;
        break;
      case "其它":
        reqData.platform = 4;
        break;
      default:
        break;
    }
    switch (autoPay) {
      case "全部":
        reqData.autoPay = 2;
        break;
      case "手动下单":
        reqData.autoPay = 0;
        break;
      case "自动下单":
        reqData.autoPay = 1;
        break;
      default:
        break;
    }
    switch (selectedTab) {
      case "all":
        reqData.isHot = 0;
        break;
      case "hot":
        reqData.isHot = 1;
        break;
      case "new":
        reqData.isHot = 2;
        break;
      default:
        break;
    }
    this.setState({ loading: true });
    this.setState({
      goods_list: [],
    });
    reqData.receiveProvince = '';
    reqData.receiveCity = '';
    if(value&&Array.isArray(value)&&value.length>1){
      reqData.receiveProvince = value[0];
      reqData.receiveCity = value[1];
    }

    API.postCityGoodsList(reqData).then((res) => {
      this.setState({ loading: false });
      if (res.status * 1 === 0) {
        let { goods_list } = this.state;
        const data = res.extData || {};
        goods_list = goods_list.concat(data.list || []);
        const collectArr = [],
          noCollectArr = [];
        goods_list.map((item) => {
          item.isCollect * 1 === 1
            ? collectArr.push(item)
            : noCollectArr.push(item);
        });
        this.setState({
          goods_list: collectArr.concat(noCollectArr),
          hasMore: goods_list.length !== data.total * 1,
        });
      } else {
        message.error(res.message || "数据加载错误");
        this.setState({ hasMore: false });
      }
    });
  };

  // handleProvinceChange = (value) => {
  //   this.setState({
  //     cities: cityData[value],
  //     province:value,
  //     secondCity:"",
  //   })

  //   let data = [];

  // };

  // onSecondCityChange = (value) => {
  //   const { province } = this.state;
  //   if(province){
  //     this.setState({
  //       secondCity:value
  //     })
  //   }else{
  //     this.setState({
  //       secondCity:''
  //     })
  //     message.warn({
  //      content:"请先选择省份",
  //      style: {
  //        fontSize: 18,      
  //     }
  //   })
  //   }
  // };

  render() {
    const {
      // isShowBuy,
      sortBy,
      type1,
      type2,
      goods_list,
      loading,
      hasMore,
      address,
      address_list,
      courier,
      platform,
      autoPay,
      // isAddressRotate,
      // isCourierRotate,
      isPlatformRotate,
      isPlatformRotatePlace,
      isOvertimeRotate,
      overtimePaid,
      isShowModal,
      courier_list,
      platform_list,
      isLine,
      imgType,
      goodsId,
      isShowAuth,
      options,
      canUse,
      isShowModalImg,
      imgVisible, // 新增状态
      selectedTab
    } = this.state;
    const { isLogin } = this.context;
    
    return (
      <div className="home">
        <Carousel autoplay style={{marginBottom: 10}}>
        {/* className="home_banner1" */}
          <div
            style={{ 
              transition: 'max-height 0.5s ease, opacity 0.3s ease 0.2s',
              // height: imgVisible ? '150px' : '0px',
              // opacity: imgVisible ? 1 : 0,
              // pointerEvents: imgVisible ? 'auto' : 'none',
              // overflow: 'hidden',
              width: '100%',
              cursor: 'pointer',
              marginBottom: 10,
              display: 'block' // 确保img保持块级特性
            }}
          >
            <Carousel autoplay>
              <div className="banner-slide">
                {/* 主图 */}
                <img 
                  src={require("../../assets/banner2.jpg")} 
                  style={{ height:'150px', width:'100%' }}
                  alt="banner"
                />
                {/* 广告遮罩与跳转 */}
                <a
                  className="banner-ad"
                  href="https://df.duoduolang.com/#/help"
                  target="_blank"
                  rel="noopener noreferrer"
                  aria-label="电商法律与税务咨询服务"
                >
                  <div className="banner-ad-content">
                    <div className="banner-ad-title">账户冻结？税务困扰？店铺经营遇到棘手问题？</div>
                    {/* <div className="banner-ad-title">店铺经营遇到棘手问题？</div> */}
                    <div className="banner-ad-sub">一键点击，直达法律咨询，助您电商经营无忧。</div>
                    <div className="banner-ad-btn">立即前往</div>
                  </div>
                </a>
              </div>
              {/*<div><img src={"https://dfcdn2.abc11223.com/source/daifa/ztc.png"}/></div>*/}
            </Carousel>
          </div>
          {/* <div
            className="home_banner"
            onClick={() => {
              this.setState({ isShowModal: true });
            }}
          ></div> */}
        </Carousel>
        <Affix offsetTop={0}>
          {/* <div>
            <div className="home_box flex-start">
              <div
                className={`home_sort flex-center ${
                  sortBy === "goods_fee" ? "home_sort_active" : ""
                }`}
                onClick={(_) => this.changeSort("goods_fee", "type1")}
              >
                价格排序
                {sortBy === "goods_fee" ? (
                  <IconFont
                    type={
                      type1 === 1 ? "icon-icon-test" : "icon-icon-test-copy"
                    }
                    style={{ fontSize: 20 }}
                  />
                ) : (
                  <IconFont
                    type="icon-icon-test-copy-copy"
                    style={{ fontSize: 20 }}
                  />
                )}
              </div>
              <div
                className={`home_sort flex-center ${
                  sortBy === "weight" ? "home_sort_active" : ""
                }`}
                onClick={(_) => this.changeSort("weight", "type2")}
              >
                重量排序
                {sortBy === "weight" ? (
                  <IconFont
                    type={
                      type2 === 1 ? "icon-icon-test" : "icon-icon-test-copy"
                    }
                    style={{ fontSize: 20 }}
                  />
                ) : (
                  <IconFont
                    type="icon-icon-test-copy-copy"
                    style={{ fontSize: 20 }}
                  />
                )}
              </div>
              <div className="home_sort_other">
                <Dropdown
                  overlay={this.renderMenuItem(
                    address_list,
                    address,
                    "address",
                    "address"
                  )}
                  trigger={["click"]}
                  placement="bottomCenter"
                  onVisibleChange={(e) => this.setState({ isAddressRotate: e })}
                  disabled={sortBy === "collect"}
                >
                  <div>
                    {address ? address : "发货地"}
                    <IconFont
                      type="icon-jiantou"
                      style={{
                        fontSize: 16,
                        marginLeft: 6,
                        transition: "transform 0.3s",
                        transform: isAddressRotate ? "rotate(180deg)" : "",
                      }}
                    />
                  </div>
                </Dropdown>
              </div>
              <div className="home_sort_other">
                <Dropdown
                  overlay={this.renderMenuItem(
                    courier_list,
                    courier,
                    "courier",
                    "courier"
                  )}
                  trigger={["click"]}
                  placement="bottomCenter"
                  onVisibleChange={(e) => this.setState({ isCourierRotate: e })}
                  disabled={sortBy === "collect"}
                >
                  <div>
                    {courier ? courier : "快递"}
                    <IconFont
                      type="icon-jiantou"
                      style={{
                        fontSize: 16,
                        marginLeft: 6,
                        transition: "transform 0.3s",
                        transform: isCourierRotate ? "rotate(180deg)" : "",
                      }}
                    />
                  </div>
                </Dropdown>
              </div>
              <div className="home_sort_other">
                <Dropdown
                  overlay={this.renderMenuItem(
                    platform_list,
                    platform,
                    "platform",
                    "plat"
                  )}
                  trigger={["click"]}
                  placement="bottomCenter"
                  onVisibleChange={(e) =>
                    this.setState({ isPlatformRotate: e })
                  }
                  disabled={sortBy === "collect"}
                >
                  <div>
                    {platform ? platform : "平台"}
                    <IconFont
                      type="icon-jiantou"
                      style={{
                        fontSize: 16,
                        marginLeft: 6,
                        transition: "transform 0.3s",
                        transform: isPlatformRotate ? "rotate(180deg)" : "",
                      }}
                    />
                  </div>
                </Dropdown>
              </div>
              <div className="home_sort_other">
                <Dropdown
                  overlay={this.renderMenuItem(
                    overtimePaid_list,
                    overtimePaid,
                    "overtimePaid",
                    "overtimePaid"
                  )}
                  trigger={["click"]}
                  placement="bottomCenter"
                  onVisibleChange={(e) =>
                    this.setState({ isOvertimeRotate: e })
                  }
                  disabled={sortBy === "collect"}
                >
                  <div>
                    {overtimePaid ? overtimePaid : "超时赔付"}
                    <IconFont
                      type="icon-jiantou"
                      style={{
                        fontSize: 16,
                        marginLeft: 6,
                        transition: "transform 0.3s",
                        transform: isOvertimeRotate ? "rotate(180deg)" : "",
                      }}
                    />
                  </div>
                </Dropdown>
              </div>
              <div
                className={`home_sort flex-center ${
                  sortBy === "collect" ? "home_sort_active" : ""
                }`}
                onClick={(_) => this.changeSort("collect", isLogin * 1)}
                style={{ margin: "0 0 0 390px" }}
              >
                <IconFont
                  type="icon-caidan"
                  style={{
                    fontSize: 16,
                    marginRight: 6,
                  }}
                />
                收藏夹
              </div>
            </div>
            <div
              style={{
                width: 1200,
                height: 10,
                background: "#f5f5f5",
                margin: "0 auto",
              }}
            ></div>
          </div> */}

          {/* 新版 */}
          <div className="home_new_box">
            {/* <div>
              <div>发货时间： <span style={{ color: 'red' }}>  除了重庆邮政跟长沙申通是17点前下单当天发走，广州韵达、广州申通、上海圆通 这几个是18点整，其它的全是17点半前下单当天发走</span></div>
            </div> */}
            <div style={{paddingTop:15}}>
              <div>地区：</div>
              <div>
                {address_list.map((item, idx) => (
                  <span
                    key={idx}
                    className={`${address === item.address ? "home_new_box_active" : ""
                      } home_new_box_item`}
                    onClick={() =>
                      this.handleChangeItem("address", item.address)
                    }
                  >
                    {item.address}
                  </span>
                ))}
              </div>
            </div>
            <div>
              <div>快递：</div>
              <div>
                {courier_list.map((item, idx) => (
                  <span
                    key={idx}
                    className={`${courier === item.courier ? "home_new_box_active" : ""
                      } home_new_box_item`}
                    onClick={() =>
                      this.handleChangeItem("courier", item.courier)
                    }
                  >
                    {item.courier}
                  </span>
                ))}
              </div>
            </div>
            {/* <div>
              <div>平台：</div>
              <div>
                {platform_list.map((item, idx) => (
                  <span
                    key={idx}
                    className={`${
                      platform === item.plat ? "home_new_box_active" : ""
                    } home_new_box_item`}
                    onClick={() => this.handleChangeItem("platform", item.plat)}
                  >
                    {item.plat}
                  </span>
                ))}
              </div>
            </div>
            <div>
              <div>超时赔付：</div>
              <div>
                {overtimePaid_list.map((item, idx) => (
                  <span
                    key={idx}
                    className={`${
                      overtimePaid === item.overtimePaid
                        ? "home_new_box_active"
                        : ""
                    } home_new_box_item`}
                    onClick={() =>
                      this.handleChangeItem("overtimePaid", item.overtimePaid)
                    }
                  >
                    {item.overtimePaid}
                  </span>
                ))}
              </div>
            </div> */}
            <div>
              <div className="flex-start box-screen">
              <div>筛选：</div>
                <div
                  className={`home_sort flex-center ${sortBy === "goods_fee" ? "home_sort_active" : ""
                    }`}
                  style={{ marginLeft: '24px' }}
                  onClick={(_) => this.changeSort("goods_fee", "type1")}
                >
                  价格排序
                  {sortBy === "goods_fee" ? (
                    <IconFont
                      type={
                        type1 === 1 ? "icon-icon-test" : "icon-icon-test-copy"
                      }
                      style={{ fontSize: 20 }}
                    />
                  ) : (
                    <IconFont
                      type="icon-icon-test-copy-copy"
                      style={{ fontSize: 20 }}
                    />
                  )}
                </div>
                <div
                  className={`home_sort flex-center ${sortBy === "weight" ? "home_sort_active" : ""
                    }`}
                  onClick={(_) => this.changeSort("weight", "type2")}
                >
                  重量排序
                  {sortBy === "weight" ? (
                    <IconFont
                      type={
                        type2 === 1 ? "icon-icon-test" : "icon-icon-test-copy"
                      }
                      style={{ fontSize: 20 }}
                    />
                  ) : (
                    <IconFont
                      type="icon-icon-test-copy-copy"
                      style={{ fontSize: 20 }}
                    />
                  )}
                </div>
                <div className="home_sort_other">
                  <Dropdown
                    overlay={this.renderMenuItem(
                      platform_list,
                      platform,
                      "platform",
                      "plat"
                    )}
                    trigger={["click"]}
                    placement="bottom"
                    onOpenChange={(e) =>
                      this.setState({ isPlatformRotate: e })
                    }
                    disabled={sortBy === "collect"}
                  >
                    <div>
                      {platform ? platform : "平台"}
                      <IconFont
                        type="icon-jiantou"
                        style={{
                          fontSize: 16,
                          marginLeft: 6,
                          transition: "transform 0.3s",
                          transform: isPlatformRotate ? "rotate(180deg)" : "",
                        }}
                      />
                    </div>
                  </Dropdown>
                </div>
                <div className="home_sort_other" style={{ display: 'none' }}>
                  <Dropdown
                    overlay={this.renderMenuItem(
                      overtimePaid_list,
                      overtimePaid,
                      "overtimePaid",
                      "overtimePaid"
                    )}
                    trigger={["click"]}
                    placement="bottom"
                    onOpenChange={(e) =>
                      this.setState({ isOvertimeRotate: e })
                    }
                    disabled={sortBy === "collect"}
                  >
                    <div>
                      {overtimePaid ? overtimePaid : "是否支持超时赔付"}
                      <IconFont
                        type="icon-jiantou"
                        style={{
                          fontSize: 16,
                          marginLeft: 6,
                          transition: "transform 0.3s",
                          transform: isOvertimeRotate ? "rotate(180deg)" : "",
                        }}
                      />
                    </div>
                  </Dropdown>
                </div>
                <div className="home_sort_other">
                  <Dropdown
                    overlay={this.renderMenuPlaceItem(autoPay)}
                    trigger={["click"]}
                    placement="bottom"
                    onOpenChange={(e) =>
                      this.setState({ isPlatformRotatePlace: e })
                    }
                  >
                    <div>
                    {autoPay ? autoPay : "下单模式"}
                      <IconFont
                        type="icon-jiantou"
                        style={{
                          fontSize: 16,
                          marginLeft: 6,
                          transition: "transform 0.3s",
                          transform: isPlatformRotatePlace ? "rotate(180deg)" : "",
                        }}
                      />
                    </div>
                  </Dropdown>
                </div>
                <div className="home_sort_other">
                   <Cascader
                     options={cascaderData}
                     onChange={this.handleChange}
                     placeholder="收货地址就近搜索"
                   />
                </div>
              </div>
              {/*<div className="home_search_icon_wrapper"*/}
              {/*     style={{textAlign: "right"}}>*/}
              {/*  {isLine && (<IconFont*/}
              {/*    type="icon-liebiao"*/}
              {/*    style={{*/}
              {/*      fontSize: 16,*/}
              {/*      transition: "transform 0.3s",*/}
              {/*    }}*/}
              {/*    onClick={() => {*/}
              {/*      this.setState({isLine: !isLine})*/}
              {/*    }}/>)}*/}
              {/*  {!isLine && (<IconFont*/}
              {/*    type="icon-kapian"*/}
              {/*    style={{*/}
              {/*      fontSize: 16,*/}
              {/*      transition: "transform 0.3s",*/}
              {/*    }}*/}
              {/*    onClick={() => {*/}
              {/*      this.setState({isLine: !isLine})*/}
              {/*    }}/>)}*/}
              {/*</div>*/}
            </div>
            <div>
             <div>榜单：</div>
              <div>
                {list_data.map((item, idx) => (
                  <span
                    key={idx}
                    className={`${selectedTab === item.list ? "home_new_box_active" : ""
                      } home_new_box_item`}
                    onClick={() =>
                      this.handleChangeItem("selectedTab", item.list)
                    }
                  >
                    {item.name}
                  </span>
                ))}
                <span style={{fontSize: '12px',color: '#8b4c01'}}>注：快速揽收榜“立即购买”页面的使用说明中有具体揽收时间！</span>
              </div>

              {/* <div style={{ 
                display: 'flex',
                justifyContent: 'left',
                borderRadius: '16px',
                margin: '5px 0'
              }}> */}
                {/* 全部选项 */}
                {/* <div 
                  style={selectedStyle(selectedTab === 'all')}
                  onClick={() => this.setState({ selectedTab: 'all' }, (_) => this.getGoodsList('selectedTab'))}
                  role="radio"
                  key="tab-all"
                  aria-checked={selectedTab === 'all'}
                >
                全部
               {selectedTab === 'all' && (
                 <span style={{
                   position: 'absolute',
                   top: '-8px',
                   right: '-8px',
                   background: '#ff4757',
                   color: 'white',
                   fontSize: '12px',
                   padding: '2px 6px',
                   borderRadius: '10px',
                   transform: 'rotate(15deg)'
                 }}>NEW</span>
               )}
             </div> */}
             {/* 热销榜 */}
             {/* <div 
               style={selectedStyle(selectedTab === 'hot')}
               onClick={() => this.setState({ selectedTab: 'hot' }, (_) => this.getGoodsList('selectedTab'))}
               role="radio"
               key="tab-hot"
               aria-checked={selectedTab === 'hot'}
             >
               热销榜
               <span style={{
                 marginLeft: '8px',
                 background: selectedTab === 'hot' ? 'rgba(255,255,255,0.2)' : '#ffe8e8',
                 color: selectedTab === 'hot' ? 'white' : '#ff6b6b',
                 padding: '2px 8px',
                 borderRadius: '4px',
                 fontSize: '12px'
               }}>HOT</span>
             </div> */}
       
             {/* 潜力榜 */}
             {/* <div 
               style={selectedStyle(selectedTab === 'potential')}
               onClick={() => this.setState({ selectedTab: 'potential' })}
               role="radio"
               aria-checked={selectedTab === 'potential'}
             >
               潜力榜
               <span style={{
                 marginLeft: '8px',
                 background: selectedTab === 'potential' ? 'rgba(255,255,255,0.2)' : '#e8f4ff',
                 color: selectedTab === 'potential' ? 'white' : '#4dabf7',
                 padding: '2px 8px',
                 borderRadius: '4px',
                 fontSize: '12px'
               }}>↑↑↑</span>
             </div>
              </div> */}
            </div>
            <div
              style={{
                width: 1200,
                height: 10,
                background: "#f5f5f5",
                margin: "0 auto",
              }}
            ></div>

            <div style={{width: 1200,height:'30px',background: "#f5f5f5",fontSize: '12px',color: '#8b4c01'}}><SoundOutlined /> 温馨提示：17点截单 17点前下单当日晚上统一揽收  反之在次日揽收；如需快速揽收，可点击快速揽收榜选择商品。</div>
          </div>
        </Affix>
        <InfiniteScroll
          initialLoad={false}
          loadMore={this.handleMoreGoodList}
          hasMore={!loading && hasMore}
          threshold={100}>
          {!isLine && (<div
            style={{
              width: 1200,
              margin: "0 auto",
            }}
          >
            {goods_list.map((item, idx) => (
              <div
                key={item.goodsId}
                className="new_home_goods flex-start"
                style={{ marginTop: idx * 1 === 0 ? 0 : 10 }}
              >
                <div style={{ position: "relative" }}>
                  <img
                    src={
                      item.productPhoto1
                        ? `${item.productPhoto1}`
                        : `${imgRoot}/photo.png`
                    }
                    alt=""
                  />
                  <div className="new_home_goods_icon">产品实拍</div>
                </div>
                <div style={{ position: "relative" }}>
                  <img
                    src={
                      item.productPhoto2
                        ? `${item.productPhoto2}`
                        : `${imgRoot}/photo.png`
                    }
                    alt=""
                  />
                  <div className="new_home_goods_icon">产品实拍</div>
                </div>
                <div style={{ position: "relative" }}>
                  <img
                    src={
                      item.packagePhoto
                        ? `${item.packagePhoto}`
                        : `${imgRoot}/photo.png`
                    }
                    alt=""
                  />
                  <div className="new_home_goods_icon">包裹实拍</div>
                </div>
                <div style={{ position: "relative" }}>
                  <img
                    src={
                      item.warehousePhoto
                        ? `${item.warehousePhoto}`
                        : `${imgRoot}/photo.png`
                    }
                    alt=""
                  />
                  <div className="new_home_goods_icon">供应商认证</div>
                </div>
                <div style={{ position: "relative" }}>
                  <img
                    src={
                      item.goodsImg
                        ? `${item.goodsImg}`
                        : `${imgRoot}/photo.png`
                    }
                    alt=""
                    style={{ marginRight: 30 }}
                  />
                  <div
                    className="new_home_goods_icon"
                    style={{ background: "rgba(51,170,255,1)" }}
                  >
                    主图
                  </div>
                </div>
                <div className="new_home_goods_info flex-column-between">
                  <div
                    style={{ display: "flex", justifyContent: "flex-start" }}
                  >
                    <div className="new_home_goods_title">{item.goodsName}</div>
                    <Tooltip
                      placement="top"
                      title={item.isCollect * 1 ? "取消收藏" : "收藏商品"}
                    >
                      {/* <IconFont
                        type={item.isCollect * 1 === 0 ? <StarOutlined /> : <StarFilled />}
                        style={{ fontSize: 24, marginTop: 2, marginLeft: 6 }}
                        onClick={(e) =>
                          this.handleCollect(
                            item.goodsId,
                            item.isCollect * 1,
                            isLogin * 1,
                            idx,
                            e
                          )
                        }
                      /> */}
                      {item.isCollect * 1 === 0 ? (
                        <StarOutlined
                          style={{ fontSize: 20, marginTop: 2, marginLeft: 6 }}
                          onClick={(e) =>
                            this.handleCollect(
                              item.goodsId,
                              item.isCollect * 1,
                              isLogin * 1,
                              idx,
                              e
                            )
                          }
                        />
                      ) : (
                        <StarFilled
                          style={{ fontSize: 20, marginTop: 2, marginLeft: 6}}
                          onClick={(e) =>
                            this.handleCollect(
                              item.goodsId,
                              item.isCollect * 1,
                              isLogin * 1,
                              idx,
                              e
                            )
                          }
                        />
                      )}
                    </Tooltip>
                  </div>
                  <div>
                    <div className="flex-start">
                      <div
                        style={{
                          color: "#FF3333",
                          fontSize: 14,
                          marginRight: 6,
                        }}
                      >
                        ￥
                        <span
                          style={{
                            fontSize: 24,
                            fontWeight: 600,
                          }}
                        >
                          {(item.goodsFee / 100).toFixed(2)}
                        </span>
                      </div>
                      {/* <div className="home_baoyou">包邮</div> */}
                      {item.overtimePaid * 1 === 1 && (
                        <Tooltip
                          placement="top"
                          title={
                            <span>
                              1、出单超时赔付
                              <br />
                              该商品已加入出单超时赔付计划，最迟在完成付款时间的基础上延迟2小时完成打单发货。（例如：10:00付款的订单，必须在12:00前完成打单发货）如果超时，我们将给您赔付补偿。
                              <br />
                              2、揽收超时赔付
                              <br />
                              该商品已加入揽收超时赔付计划，当天18:00点前完成付款的包裹，需在第二天12:00前产生揽收记录，如果超时，我们将给您赔付补偿
                              <br />
                              当天18:00点后完成付款的包裹，需在第二天24:00前产生揽收记录，如果超时，我们将给您赔付补偿。
                              <br />
                              3、赔付金额
                              <br />
                              低于2元的商品，我们将按商品实际包邮价格，全额赔付；高于2元的商品，我们将全部按照2元赔付。
                            </span>
                          }
                        >
                          <img
                            src={`${imgRoot}/chaoshi.svg`}
                            alt=""
                            style={{
                              display: "block",
                              width: 76,
                              height: 22,
                              cursor: "pointer",
                            }}
                          />
                        </Tooltip>
                      )}
                    </div>
                    <div style={{ color: "#7A8399", marginBottom: 10 }}>
                      {item.weight}g/件
                    </div>
                    <Button
                      type="primary"
                      style={{
                        width: "100%",
                        height: 24,
                        fontSize: 12,
                        padding: 0,
                        marginBottom: 10,
                      }}
                      onClick={(_) => this.handlePay(item)}
                    >
                      立即购买
                    </Button>
                    {/* {canUse == 2 ? '' : (
                      <Button
                        type="primary"
                        style={{
                          width: "100%",
                          height: 24,
                          fontSize: 12,
                          padding: 0,
                          marginBottom: 10,
                        }}
                        onClick={(_) => this.handlePay(item)}
                      >
                        立即购买
                      </Button>
                    )} */}
                    <div className="flex-space">
                      <div className="new_home_goods_local">{item.address}</div>
                      <div className="new_home_goods_local flex-center">
                        <img src={item.courierImg} alt="" width="56px" height="24px" />
                      </div>
                      <div className="new_home_goods_local">包邮</div>
                      {/* <div
                        className="new_home_goods_local"
                        style={{ borderColor: "#ff3333", color: "#ff3333" }}
                      >
                        立即购买
                      </div> */}
                    </div>
                  </div>
                  {/* <Tooltip
                    placement="top"
                    title={item.isCollect * 1 ? "取消收藏" : "收藏商品"}
                  >
                    <div
                      className="home_collect flex-center"
                      onClick={(e) =>
                        this.handleCollect(
                          item.goodsId,
                          item.isCollect * 1,
                          isLogin * 1,
                          idx,
                          e
                        )
                      }
                      style={{
                        width: item.isCollect * 1 === 1 ? 66 : 30,
                      }}
                    >
                      <IconFont
                        type="icon-shoucang1"
                        style={{ fontSize: 18 }}
                      />
                      {isLogin * 1 === 1 &&
                        item.isCollect * 1 === 1 &&
                        "已收藏"}
                    </div>
                  </Tooltip> */}
                </div>
              </div>
            ))}
          </div>)}

          {isLine && (<div
            style={{
              width: 1200,
              margin: "0 auto",
              display: "flex",
              flexWrap: "wrap",
            }}>
            {/*{goods_list.length && (<div*/}
            {/*  key="jmabc"*/}
            {/*  className="new_home_goods_flex"*/}
            {/*  style={{ marginRight: 12}}*/}
            {/*  onClick={() => {*/}
            {/*    if (window._hmt) {*/}
            {/*      window._hmt.push(['_trackEvent', 'home', 'link', 'jmmd'])*/}
            {/*    }*/}
            {/*    window.open("https://www.jmabc.com/#/?fr=xtdf");*/}
            {/*  }*/}
            {/*  }>*/}
            {/*  <img*/}
            {/*    style={{width: 230, height: 400, cursor: 'pointer'}}*/}
            {/*    src="https://img.jmabc.com/common/images/df_banner.png"/>*/}
            {/*</div>)}*/}
            {goods_list.map((item, idx) => (
              <div
                key={item.goodsId}
                style={{ marginRight: idx === 4 ? 0 : (idx % 5 === 4 ? 0 : 12), borderRadius: '4px'}}
                className="new_home_goods_flex">
                <div style={{ position: "relative", cursor: 'pointer' }}
                  onClick={(_) => this.handlePay(item)}>
                  {goodsId !== item.goodsId && (<div>
                    <img
                      style={{borderRadius: '4px'}}
                      src={
                        item.goodsImg
                          ? `${item.goodsImg}?imageMogr2/crop/230x230/gravity/center`
                          : `${imgRoot}/photo.png`
                      }
                      alt=""
                    />
                    {/* <div style={{position:'absolute',bottom: '5px',right: '5px'}}>
                      {item.sourceYc==1?(
                        <span style={{ color: 'red',fontWeight:'bold'}}>支持（拼多多,淘宝,抖音,京东）店铺自动下单</span>
                      ):<span style={{ color: 'red',fontWeight:'bold' }}> </span>}
                    </div> */}
                  </div>)}
                  {imgType === 'pro1' && goodsId === item.goodsId && (
                    <div style={{ position: "relative" }}>
                      <img
                        style={{borderRadius: '4px'}}
                        src={
                          item.productPhoto1
                            ? `${item.productPhoto1}?imageMogr2/crop/230x230/gravity/center`
                            : `${imgRoot}/photo.png`
                        }
                        alt=""
                      />
                      <div className="new_home_goods_icon">产品实拍</div>
                    </div>)}
                  {imgType === 'pro2' && goodsId === item.goodsId && (
                    <div style={{ position: "relative" }}>
                      <img
                        style={{borderRadius: '4px'}}
                        src={
                          item.productPhoto2
                            ? `${item.productPhoto2}?imageMogr2/crop/230x230/gravity/center`
                            : `${imgRoot}/photo.png`
                        }
                        alt=""
                      />
                      <div className="new_home_goods_icon">产品实拍</div>
                    </div>)}
                  {imgType === 'package' && goodsId === item.goodsId && (
                    <div style={{ position: "relative" }}>
                      <img
                        style={{borderRadius: '4px'}}
                        src={
                          item.packagePhoto
                            ? `${item.packagePhoto}?imageMogr2/crop/230x230/gravity/center`
                            : `${imgRoot}/photo.png`
                        }
                        alt=""
                      />
                      <div className="new_home_goods_icon">包裹实拍</div>
                    </div>)}
                  {imgType === 'warehouse' && goodsId === item.goodsId && item.sourceYc!==0 && (
                    <div style={{ position: "relative" }}>
                      <img
                        style={{borderRadius: '4px'}}
                        src={
                          item.warehousePhoto
                            ? `${item.warehousePhoto}`
                            : `${imgRoot}/photo.png`
                        }
                        alt=""
                      />
                      <div className="new_home_goods_icon">供应商认证</div>
                    </div>)}
                    {imgType === 'warehouse' && goodsId === item.goodsId && item.sourceYc===0 && (
                    <div style={{ position: "relative" }}>
                      <img
                        style={{borderRadius: '4px'}}
                        src={require("../../assets/gys.png")}
                        alt=""
                      />
                      <div className="new_home_goods_icon">供应商认证</div>
                    </div>)}
                </div>
                <div className="new_home_goods_info_flex">
                  <div
                    className="new_home_goods_title_wrapper flex-space">
                    <div
                      className="new_home_goods_title_flex"
                      style={{borderRadius: '4px'}}
                      title={item.goodsName}>
                      {item.goodsName}
                    </div>
                    <div className="icon">
                      <Tooltip
                        placement="top"
                        title={item.isCollect * 1 ? "取消收藏" : "收藏商品"}>
                        {/* <IconFont
                          // type={`${
                          //   item.isCollect * 1 === 0
                          //     // ? "icon-shoucang"
                          //     // : "icon-shoucang2"
                          //   }`}
                          style={{fontSize: 24, marginTop: 2, marginLeft: 6}}
                          onClick={(e) =>
                            this.handleCollect(
                              item.goodsId,
                              item.isCollect * 1,
                              isLogin * 1,
                              idx,
                              e
                            )}/> */}
                        {item.isCollect * 1 === 0 ? (
                          <StarOutlined
                            style={{ fontSize: 20, marginTop: 2, marginLeft: 6,color: '#33aaff' }}
                            onClick={(e) =>
                              this.handleCollect(
                                item.goodsId,
                                item.isCollect * 1,
                                isLogin * 1,
                                idx,
                                e
                              )
                            }
                          />
                        ) : (
                          <StarFilled
                            style={{ fontSize: 20, marginTop: 2, marginLeft: 6,color: '#33aaff' }}
                            onClick={(e) =>
                              this.handleCollect(
                                item.goodsId,
                                item.isCollect * 1,
                                isLogin * 1,
                                idx,
                                e
                              )
                            }
                          />
                        )}
                      </Tooltip>
                    </div>
                  </div>
                  <div>
                    <div className="new_home_goods_price_flex flex-space">
                      <div style={{ color: "#FF3333" }}>
                      <span style={{ fontSize: 14, marginRight: 3,fontWeight: 500 }}>￥</span>
                        {
                          item.sourceYc === 1 && item.specialPriceScope === 1  ? (
                            <div className="new_home_goods_priceScope_flex" style={{ fontSize: 20, fontWeight: 600 }} title={item.priceScope}>
                              <span style={{ fontSize: 14, fontWeight: 500,display:'inline-block',marginTop:2 }}>最低</span>{item.priceScope}
                            </div>
                          ) : item.sourceYc === 1 ? (
                              <div className="new_home_goods_priceScope_flex" style={{ fontSize: 20, fontWeight: 600 }} title={item.priceScope}>
                                {item.priceScope}
                              </div>
                          ) : (
                              <span style={{ fontSize: 20, fontWeight: 600 }}>
                                {(item.goodsFee / 100).toFixed(2)}
                              </span>
                          )
                        }
                        {item.overtimePaid * 1 === 1 && (
                          <Tooltip
                            placement="top"
                            title={
                              <span>
                                1、出单超时赔付
                                <br />
                                该商品已加入出单超时赔付计划，最迟在完成付款时间的基础上延迟2小时完成打单发货。（例如：10:00付款的订单，必须在12:00前完成打单发货）如果超时，我们将给您赔付补偿。
                                <br />
                                2、揽收超时赔付
                                <br />
                                该商品已加入揽收超时赔付计划，当天18:00点前完成付款的包裹，需在第二天12:00前产生揽收记录，如果超时，我们将给您赔付补偿
                                <br />
                                当天18:00点后完成付款的包裹，需在第二天24:00前产生揽收记录，如果超时，我们将给您赔付补偿。
                                <br />
                                3、赔付金额
                                <br />
                                低于2元的商品，我们将按商品实际包邮价格，全额赔付；高于2元的商品，我们将全部按照2元赔付。
                              </span>
                            }>
                            <img
                              src={`${imgRoot}/chaoshi.svg`}
                              alt=""
                              style={{
                                display: "inline-block",
                                width: 61,
                                height: 22,
                                cursor: "pointer",
                                marginBottom: 1,
                                marginLeft: 1,
                              }}
                            />
                          </Tooltip>
                        )}
                      </div>
                      <div style={{ color: "#7A8399" }}>
                        {item.weight}g/件
                      </div>
                    </div>
                    <div style={{ marginLeft: 4}}>
                    {
                        item.autoPay == 1 ? (
                            <Tag  
                              style={{padding:'0 3px',color: 'rgb(182 137 86)',border: '1px solid #c5a580',borderRadius: '4px',background:'#fff'}}
                            >支持自动下单</Tag>
                        ) : ''
                      }
                      <span 
                        className="new_home_goods_local_flex" 
                        style={{ marginLeft: 4, padding:'4px 3px',color: 'rgb(182 137 86)',border: '1px solid #c5a580',borderRadius: '4px',background:'#fff'}}
                      >包邮</span>
                    </div>
                  </div>

                  <div className="flex-space" style={{ marginTop: 8, }}>
                    <div className="new_home_goods_local" style={{borderRadius: '4px'}}>{item.address}</div>
                    <div className="new_home_goods_local flex-center" style={{borderRadius: '4px'}}>
                      <img src={item.courierImg} alt="" width="56px" height="24px" />
                    </div>
                    {/* {canUse == 2 ? '' : (
                      <Button
                        type="primary"
                        style={{
                          width: 80,
                          height: 24,
                          fontSize: 12,
                          padding: 0
                        }}
                        onClick={() => this.handlePay(item)}>
                        立即购买
                      </Button>
                    )} */}
                    <Button
                      type="primary"
                      style={{
                        width: 80,
                        height: 24,
                        fontSize: 12,
                        padding: 0,
                        borderRadius: '4px'
                      }}
                      onClick={() => this.handlePay(item)}>
                      立即购买
                    </Button>
                  </div>
                  <div className="img_wrapper flex-space-colstart" style={{ marginTop: '10px' }}>
                    <img
                      style={{ width: '48px', height: '48px', borderRadius: '4px', objectFit: 'cover', cursor: 'pointer' }}
                      src={
                        item.productPhoto1
                          ? `${item.productPhoto1}?imageMogr2/crop/48x48/gravity/center`
                          : `${imgRoot}/photo.png`
                      }
                      alt=""
                      onMouseEnter={() => { this.setState({ imgType: 'pro1', goodsId: item.goodsId }) }}
                      onMouseLeave={() => { this.setState({ imgType: 'main', goodsId: '' }) }}
                    />
                    <img
                      style={{ width: '48px', height: '48px', borderRadius: '4px', objectFit: 'cover', cursor: 'pointer' }}
                      src={
                        item.productPhoto2
                          ? `${item.productPhoto2}?imageMogr2/crop/48x48/gravity/center`
                          : `${imgRoot}/photo.png`
                      }
                      alt=""
                      onMouseEnter={() => { this.setState({ imgType: 'pro2', goodsId: item.goodsId }) }}
                      onMouseLeave={() => { this.setState({ imgType: 'main', goodsId: '' }) }}
                    />
                    <img
                      style={{ width: '48px', height: '48px', borderRadius: '4px', objectFit: 'cover', cursor: 'pointer' }}
                      src={
                        item.packagePhoto
                          ? `${item.packagePhoto}?imageMogr2/crop/48x48/gravity/center`
                          : `${imgRoot}/photo.png`
                      }
                      alt=""
                      onMouseEnter={() => { this.setState({ imgType: 'package', goodsId: item.goodsId }) }}
                      onMouseLeave={() => { this.setState({ imgType: 'main', goodsId: '' }) }}
                    />
                    <img
                      style={{ width: '48px', height: '48px', borderRadius: '4px', objectFit: 'cover', cursor: 'pointer' }}
                      // src={"https://cdn.abc11223.com/source/daifa/authImage.png"}
                      src={
                        item.warehousePhoto
                          ? `${item.warehousePhoto}?imageMogr2/crop/48x48/gravity/center`
                          : `${imgRoot}/photo.png`
                      }
                      alt=""
                      onMouseEnter={() => { this.setState({ imgType: 'warehouse', goodsId: item.goodsId }) }}
                      onMouseLeave={() => { this.setState({ imgType: 'main', goodsId: '' }) }}
                    />
                  </div>
                </div>
              </div>
            ))}
          </div>)}

          {/* <div
            className="flex-start"
            style={{
              flexWrap: "wrap",
              width: 1200,
              minHeight: 200,
              margin: "0 auto",
            }}
          >
            {goods_list.map((item, idx) => (
              <div
                key={item.goodsId}
                className="home_goods"
                style={{ marginRight: (idx + 1) % 5 === 0 ? 0 : 25 }}
                onMouseEnter={(_) => this.setState({ isShowBuy: item.goodsId })}
                onMouseLeave={(_) => this.setState({ isShowBuy: "" })}
                onClick={(_) => {
                  history.push(`/seller/goods/goodsinfo?${item.goodsId}`);
                }}
              >
                <div className="home_goods_img">
                  <img src={item.goodsImg} alt="" />
                </div>
                <div className="home_goods_info flex-column-between">
                  <div className="home_goods_title">{item.goodsName}</div>
                  <div className="flex-space">
                    <div className="flex-start">
                      <div
                        style={{
                          fontSize: 20,
                          fontWeight: 600,
                          color: "#ff3333",
                          marginRight: 10,
                        }}
                      >
                        ￥{(item.goodsFee / 100).toFixed(2)}
                      </div>
                      <div className="home_goods_baoyou">包邮</div>
                    </div>
                    <div style={{ fontSize: 12, color: "#666666" }}>
                      {item.weight}g/件
                    </div>
                  </div>
                  <div className="flex-space">
                    <div className="home_goods_local">{item.address}</div>
                    <div className="home_goods_local">{item.courier}</div>
                  </div>
                </div>
                <div
                  className="home_goods_hover"
                  style={{
                    display: isShowBuy === item.goodsId ? "block" : "none",
                    // display: "block",
                  }}
                >
                  <div className="flex-start home_goods_hover_info">
                      <div className="home_goods_hover_title">发货详情</div>
                      <div className="home_goods_hover_line"></div>
                      <div
                        className="home_goods_hover_detail flex-column-between"
                        style={{ height: 118 }}
                      >
                        <div>出单截止时间：23:59:59</div>
                        <div>发货截止时间：23:59</div>
                        <div>仓储：义乌</div>
                        <div>快递：韵达</div>
                        <div>不发：新疆、西藏</div>
                      </div>
                    </div>
                    <div className="flex-start home_goods_hover_info">
                      <div className="home_goods_hover_title">物流时效</div>
                      <div className="home_goods_hover_line"></div>
                      <div
                        className="home_goods_hover_detail flex-column-between"
                        style={{ height: 118 }}
                      >
                        <div>
                          平均出单时间：8分钟
                          <Tooltip
                            placement="top"
                            title="平均出单时间：近三天，在9:00至18:00时间段，下单到出单号的平均时长=【（A包裹下单时间-A包裹出单时间）+（B包裹下单时间-B包裹出单时间）+（C包裹下单时间-C包裹出单时间）】/ (A+B+C)单量"
                          >
                            <IconFont
                              type="icon-bangzhu"
                              style={{
                                fontSize: 14,
                                color: "#333333",
                                marginLeft: 2,
                              }}
                            />
                          </Tooltip>
                        </div>
                        <div>
                          平均揽收时间：6小时
                          <Tooltip
                            placement="top"
                            title="平均揽收时间：近三天，在9:00至18:00时间段，下单到出单号的平均时长=【（A包裹下单时间-A包裹揽收时间）+（B包裹下单时间-B包裹揽收时间）+（C包裹下单时间-C包裹揽收时间）】/ (A+B+C)单量"
                          >
                            <IconFont
                              type="icon-bangzhu"
                              style={{
                                fontSize: 14,
                                color: "#333333",
                                marginLeft: 2,
                              }}
                            />
                          </Tooltip>
                        </div>
                        <div>
                          24小时揽收率：70%
                          <Tooltip
                            placement="top"
                            title="24小时揽收率：近三天，下单后，在24h内完成揽收的比例=【（包裹出单时间-包裹揽收时间）<24h】的单量/总单量"
                          >
                            <IconFont
                              type="icon-bangzhu"
                              style={{
                                fontSize: 14,
                                color: "#333333",
                                marginLeft: 2,
                              }}
                            />
                          </Tooltip>
                        </div>
                        <div>
                          中转超时率：5%
                          <Tooltip
                            placement="top"
                            title="中转超时率：近三天，物流中转停留超过48小时的比例= 【已揽收包裹（物流信息最后一次更新时间 - 当下时间）>48h 的单量】/已揽收包裹总单量 "
                          >
                            <IconFont
                              type="icon-bangzhu"
                              style={{
                                fontSize: 14,
                                color: "#333333",
                                marginLeft: 2,
                              }}
                            />
                          </Tooltip>
                        </div>
                      </div>
                    </div>
                    <div className="home_goods_title">{item.goodsName}</div>
                    <div className="flex-space">
                      <div className="flex-start">
                        <div
                          style={{
                            fontSize: 20,
                            fontWeight: 600,
                            color: "#ff3333",
                            marginRight: 10,
                          }}
                        >
                          ￥{(item.goodsFee / 100).toFixed(2)}
                        </div>
                        <div className="home_goods_baoyou">包邮</div>
                      </div>
                      <div style={{ fontSize: 12, color: "#666666" }}>
                        {item.weight}g/件
                      </div>
                    </div>
                  <div className="home_goods_buy">立即购买</div>
                </div>
              </div>
            ))}
          </div> */}
          {loading && (
            <div style={{ textAlign: "center", margin: 20 }}>
              <Spin size="large" tip="努力加载中" />
            </div>
          )}
        </InfiniteScroll>
        <div
          style={{
            fontSize: 14,
            color: "#999999",
            textAlign: "center",
            margin: 24,
          }}
        >
          {hasMore ? "下拉加载更多" : "暂无更多商品"}
        </div>
        <Modal
          open={isShowModal}
          footer={null}
          onCancel={(_) => this.setState({ isShowModal: false })}
          className="modal_paid"
        >
          <div>
            <div className="modal_paid_title">
              <div style={{ fontSize: 26, color: "#33AAFF" }}>
                为迎合各平台发货规则，提升礼品服务水平，特推出超时赔付计划
              </div>
              <div className="flex-center" style={{ marginTop: 18 }}>
                有
                <img
                  src={`${imgRoot}/chaoshi.svg`}
                  alt=""
                  style={{ margin: "0 10px" }}
                />
                标识即表示该商品已加入超时赔付计划
              </div>
            </div>
            <div className="modal_paid_box">
              <div>具体赔付规则如下：</div>
              <div className="modal_paid_content">
                <div style={{ color: "#1a2133", fontWeight: 600 }}>
                  出单超时赔付
                </div>
                <div className="flex-start">
                  <div className="modal_paid_text">
                    付款后的订单最迟会在2小时内完成发货并返回快递单号
                  </div>
                  <div className="modal_paid_text" style={{ marginLeft: 40 }}>
                    例如：10点付款的订单，所有包裹必须在12点前完成发货
                  </div>
                </div>
                <div className="modal_paid_text">
                  如果超时，平台将自动给您赔付补偿
                </div>
              </div>
              <div className="modal_paid_content">
                <div style={{ color: "#1a2133", fontWeight: 600 }}>
                  揽收超时赔付
                </div>
                <div className="flex-start">
                  <div className="modal_paid_text">
                    当天18点前完成付款的包裹，需在第二天12点前产生揽收记录
                  </div>
                  <div className="modal_paid_text" style={{ marginLeft: 40 }}>
                    当天18点后完成付款的包裹，需在第二天24点前产生揽收记录
                  </div>
                </div>
                <div className="modal_paid_text">
                  如果超时，平台将自动给您赔付补偿
                </div>
              </div>
              <div className="modal_paid_content" style={{ height: 133 }}>
                <div style={{ color: "#1a2133", fontWeight: 600 }}>
                  如果觉得礼品商城靠谱好用，可以将我们分享给身边的电商朋友，邀请好友下单还可以领取现金奖励
                </div>
                <div className="flex-start" style={{ marginTop: 24 }}>
                  <div
                    style={{ width: 30, margin: "0 16px", color: "#1a2133" }}
                  >
                    邀请方式
                  </div>
                  <div>
                    <div style={{ marginBottom: 10 }}>
                      登录—个人中心—推广赚钱—复制推广链接—发到商家群/好友
                    </div>
                    <div>
                      通过您的邀请链接注册的商家用户，支付的每一单包裹，您都可以得到现金奖励！
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </Modal>
        <Modal
          width={350}
          open={isShowAuth}
          onOk={this.toAuth}
          okText="去实名"
          onCancel={(_) => this.setState({ isShowAuth: false })}>
          <div>
            <div>
              <div style={{ fontSize: 16 }}>
                请先完成实名认证
              </div>
            </div>
          </div>
        </Modal>
      </div>
    );
  }
}
export default withRouter(All);
